import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  count?: number;
  href?: string;
  linkLabel?: string;
  icon?: string;
}

export function SectionHeader({
  title,
  count,
  href,
  linkLabel = "See all",
  icon,
}: SectionHeaderProps) {
  return (
    <div className="flex items-center justify-between px-1 mb-2">
      <div className="flex items-center gap-2">
        {icon && <span className="text-base">{icon}</span>}
        <h2 className="font-bold text-[length:var(--font-section-title)]">
          {title}
        </h2>
        {count !== undefined && count > 0 && <CountBadge count={count} />}
      </div>
      {href && (
        <Link
          to={href}
          className="text-blue-500 text-sm font-medium"
        >
          {linkLabel}
        </Link>
      )}
    </div>
  );
}

function CountBadge({ count }: { count: number }) {
  return (
    <span className="text-[11px] font-semibold px-2 py-0.5 rounded-full bg-[color:var(--accent-color)]/15 text-[color:var(--accent-color)]">
      {count}
    </span>
  );
}
